(() => {
  angular
    .module('finance')
    .controller('curlecPayoutMerchantBalanceModal', CurlecPayoutMerchantBalanceModal);

    CurlecPayoutMerchantBalanceModal.$inject = [
    '$uibModalInstance',
    'abp.services.finance.curlecPayout',
  ];

  function CurlecPayoutMerchantBalanceModal($uibModalInstance, curlecPayoutSvc) {
    const vm = this;

    vm.loading = 0;
    vm.result = null;

    vm.close = close;
    init();

    function init() {
      checkMerchantBalance();
    }

    function checkMerchantBalance() {
      vm.loading += 1;
      curlecPayoutSvc
        .checkMerchantBalance()
        .success((data) => {
          vm.result = JSON.stringify(data.response, null, 2);
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function close() {
      $uibModalInstance.dismiss();
    }
  }
})();
